import type {LanguageConfig} from '@frontend/types/Locales'

export const EnLanguageConfig: Omit<LanguageConfig, 'loader'> = {
    language: 'en',
    region: 'demo',
    full: 'en-US',
    label: 'English',
    variations: ['en', 'en-us', 'en_us', 'en-gb', 'en_gb', 'en-vn', 'en-vi'],
    numeral: {
        localeConfig: {
            delimiters: {
                thousands: ' ',
                decimal: '.',
            },
            abbreviations: {
                thousand: 'k',
                million: 'm',
                billion: 'b',
                trillion: 't',
            },
            ordinal(num: number): string {
                return String(num)
            },
        },
    },
    dateTime: {
        loader: () => import('dayjs/locale/en'),
        dateFormat: 'YYYY-MM-DD',
    },
    googleMaps: {
        localization: {
            language: 'en',
            region: 'US',
        },
    },
}
